import FieldService from 'services/FieldService';

export const getSelectedOptions = (reasonsDialogData, reasonLostField) =>
  reasonsDialogData.map(({ record, stageId }) => ({
    selected: FieldService.getFieldValue(record, reasonLostField, true),
    stageId,
    recordId: record.id,
  }));
